import {
  BusinessCollectionCompType,
  IObjektVy,
} from '../../../../../Types/ObjektVy';
import { objektVyGrupp } from '../../../_Common/Components/BusinessCollectionComponents/ObjektVyGrupp';
import { collectionCompToObjektVy } from '../../../_Common/Components/BusinessCollectionComponents/BusinessCollectionUtils';
import { useCallback, useContext, useMemo } from 'react';
import ObjektVy from '../../../_Common/Components/BusinessCollectionComponents/ObjektVy/ObjektVy';
import BusinessDataForm from '../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/BusinessDataForm';
import { IClientBusinessModel } from '../../../../../Types/ClientModelTypes';
import clientAvenyModel from '../../../../../Model/clientAvenyModel';
import Attribut from '../../../_Common/Components/BusinessCollectionComponents/Attribut/Attribut';
import ObjektVySida from '../../../_Common/Components/BusinessCollectionComponents/ObjektVySida/ObjektVySida';
import AttributGrupp from '../../../_Common/Components/BusinessCollectionComponents/AttributGrupp/AttributGrupp';
import useNodeQuery from '../../../../../Components/QueryComponents/NodeQuery/useNodeQuery';
import LeverantorkatQueryDoc from './Leverantorkat.gql';
import LeverantorkatAddMutationDoc from './LeverantorkatAddMutation.gql';
import LeverantorkatUpdateMutationDoc from './LeverantorkatUpdateMutation.gql';
import {
  LeverantorkatQuery,
  LeverantorkatQueryVariables,
  LeverantorkatQuery_node_TEDLRLeverantorkat,
} from './_QueryTypes/LeverantorkatQuery';
import { useCollectionMutation } from '../../../../../Components/QueryComponents/CollectionMutation/useCollectionMutation';
import { useMutation } from '@apollo/client';
import {
  LeverantorkatUpdateMutation,
  LeverantorkatUpdateMutationVariables,
} from './_QueryTypes/LeverantorkatUpdateMutation';
import {
  LeverantorkatAddMutation,
  LeverantorkatAddMutationVariables,
} from './_QueryTypes/LeverantorkatAddMutation';
import {
  IFormData,
  removeIdsFromNewAssociations,
} from '../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/Utils/BusinessDataFormUtils';
import { TEDInputLRLeverantorkatAddValues } from '../../../../../globalQueryTypes';
import { ActiveDatabaseContext } from '../../../../../Components/ActiveDatabaseContext/ActiveDatabaseContext';
import { StandardRutinContext } from '../../../_StandardRutin/StandardRutinContext';
import { selectedId } from '../../../../../Components/MasterDetail/MasterDetailUtils';

const leverantorkatmodel: IClientBusinessModel =
  clientAvenyModel.LR.BusinessModels.LRLeverantorkat;

const LeverantorKat: BusinessCollectionCompType = props => {
  const {
    nodeData,
    loading: nodeLoading,
    refetch: nodeRefetch,
  } = useNodeQuery<
    LeverantorkatQuery,
    LeverantorkatQuery_node_TEDLRLeverantorkat,
    LeverantorkatQueryVariables
  >(LeverantorkatQueryDoc, selectedId(props.id));

  const { activeDatabase } = useContext(ActiveDatabaseContext);
  const [mutation, { loading: updateLoading, error: updateError }] =
    useCollectionMutation<
      LeverantorkatUpdateMutation,
      LeverantorkatUpdateMutationVariables
    >(LeverantorkatUpdateMutationDoc);

  const [addMutation, addStatus] = useMutation<
    LeverantorkatAddMutation,
    LeverantorkatAddMutationVariables
  >(LeverantorkatAddMutationDoc);

  const updateFunction = useCallback(
    (values: IFormData) => {
      const newValues = removeIdsFromNewAssociations(values);
      return mutation({
        variables: {
          db: activeDatabase || '',
          values: {
            id: selectedId(props.id) ?? 'id missing',
            _version: nodeData ? nodeData._version : 1,
            ...newValues,
          },
        },
      });
    },
    [mutation, activeDatabase, props.id, nodeData]
  );

  const addFunction = useCallback(
    (values: IFormData) => {
      return addMutation({
        variables: {
          db: activeDatabase || '',
          values: values as TEDInputLRLeverantorkatAddValues,
        },
      });
    },
    [addMutation, activeDatabase]
  );
  const standardRutinContext = useContext(StandardRutinContext);
  const initialValue = useMemo(
    () => ({
      BENAMNING: standardRutinContext.urval?.savedUrvalProps?.namn ?? 'blaj',
    }),
    [standardRutinContext.urval]
  );
  return (
    <BusinessDataForm<LeverantorkatQuery_node_TEDLRLeverantorkat>
      isNew={props.isNew}
      model={leverantorkatmodel}
      data={nodeData}
      refetchData={nodeRefetch}
      dataLoading={nodeLoading}
      updateMutation={updateFunction}
      addMutation={addFunction}
      mutationError={updateError || addStatus.error}
      mutationLoading={updateLoading}
      initialValue={initialValue}
    >
      <ObjektVy nodeLoading={false} editImplemented>
        <ObjektVySida
          sidNr={1}
          caption="Leverantörskategori"
          collectionName="LRLeverantorkat"
        >
          <AttributGrupp>
            <Attribut name="BENAMNING" />
            <Attribut name="INTERN" />
          </AttributGrupp>
        </ObjektVySida>
      </ObjektVy>
    </BusinessDataForm>
  );
};

export const LeverantorkatStandard: IObjektVy =
  collectionCompToObjektVy(LeverantorKat);

export const LeverantorkatMini: IObjektVy = objektVyGrupp('mini', [
  'BENAMNING',
]);

export const LeverantorkatVyer: IObjektVy[] = [
  // LeverantorkatMini,
  LeverantorkatStandard,
  // forstaSida,
];
